import type { DifficultyId } from "../game/difficulty";
import { apiUrl } from "./apiBase";

export type LeaderboardEntry = {
  rank: number;
  name: string;
  distance: number;
  playerId: string;
  seed?: string;
  stage?: string;
};

export type SubmitResult = {
  ok: boolean;
  improved: boolean;
  rank: number;
  best: number;
  total: number;
};

export async function fetchLeaderboard(
  difficulty: DifficultyId,
  limit = 15,
): Promise<LeaderboardEntry[]> {
  try {
    const r = await fetch(
      apiUrl(`/api/leaderboard?difficulty=${difficulty}&limit=${limit}`),
      { headers: { Accept: "application/json" } },
    );
    if (!r.ok) return [];
    const j = (await r.json()) as { entries?: LeaderboardEntry[] };
    return j.entries ?? [];
  } catch {
    return [];
  }
}

export async function submitScore(opts: {
  playerId: string;
  name: string;
  distance: number;
  difficulty: DifficultyId;
  seed?: string;
  stage?: string;
}): Promise<SubmitResult | null> {
  try {
    const r = await fetch(apiUrl("/api/score"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(opts),
    });
    if (!r.ok) return null;
    return (await r.json()) as SubmitResult;
  } catch {
    return null;
  }
}
